export const downloadFile = (data: { fileName: string; file: Blob }) => {
  const url = window.URL.createObjectURL(data.file)
  const link = document.createElement('a')
  link.download = data.fileName
  link.href = url
  link.click()
}
